<template>
  <div class="fillcontain">
    <!-- 顶部卡片区域 -->
    <el-row :gutter="20" class="dashboard-card">
      <el-col :span="4">
        <el-card shadow="hover" class="card-item total-card">
          <div class="card-content">
            <div class="card-icon">
              <i class="el-icon-office-building"></i>
            </div>
            <div class="card-info">
              <div class="card-title">总租赁数量</div>
              <div class="card-number">{{ dashboardData.totalCount }}</div>
              <div class="card-trend" v-if="dashboardData.trend.total > 0">
                ↑ {{ dashboardData.trend.total }}%
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" class="card-item active-card">
          <div class="card-content">
            <div class="card-icon">
              <i class="el-icon-s-claim"></i>
            </div>
            <div class="card-info">
              <div class="card-title">租赁中</div>
              <div class="card-number">{{ dashboardData.activeCount }}</div>
              <div class="card-subtitle">占比 {{ dashboardData.activePercentage }}%</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" class="card-item warning-card">
          <div class="card-content">
            <div class="card-icon">
              <i class="el-icon-warning-outline"></i>
            </div>
            <div class="card-info">
              <div class="card-title">即将到期</div>
              <div class="card-number">{{ dashboardData.willExpireCount }}</div>
              <div class="card-subtitle">30天内到期</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" class="card-item arrears-card">
          <div class="card-content">
            <div class="card-icon">
              <i class="el-icon-s-finance"></i>
            </div>
            <div class="card-info">
              <div class="card-title">欠租租赁</div>
              <div class="card-number">{{ dashboardData.arrearsCount }}</div>
              <div class="card-subtitle">总欠租 ¥{{ dashboardData.totalArrears | currency }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" class="card-item expired-card">
          <div class="card-content">
            <div class="card-icon">
              <i class="el-icon-time"></i>
            </div>
            <div class="card-info">
              <div class="card-title">已到期</div>
              <div class="card-number">{{ dashboardData.expiredCount }}</div>
              <div class="card-subtitle">待续签/退租</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" class="card-item revenue-card">
          <div class="card-content">
            <div class="card-icon">
              <i class="el-icon-money"></i>
            </div>
            <div class="card-info">
              <div class="card-title">租金总额</div>
              <div class="card-number">{{ dashboardData.totalRentalAmount | currency }}</div>
              <div class="card-subtitle">所有租赁租金总和</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 筛选和操作区域 -->
    <el-card class="filter-card" shadow="never">
      <div slot="header" class="clearfix">
        <span class="filter-title">
          <i class="el-icon-search"></i>
          筛选条件
        </span>
        <div class="filter-actions">
          <el-button-group>
            <el-button 
              type="primary" 
              size="small" 
              @click="handleQuickFilter('active')"
              :class="{'is-active': quickFilter === 'active'}"
            >
              租赁中
            </el-button>
            <el-button 
              type="warning" 
              size="small" 
              @click="handleQuickFilter('expiring')"
              :class="{'is-active': quickFilter === 'expiring'}"
            >
              即将到期
            </el-button>
            <el-button 
              type="danger" 
              size="small" 
              @click="handleQuickFilter('arrears')"
              :class="{'is-active': quickFilter === 'arrears'}"
            >
              欠租
            </el-button>
            <el-button 
              type="info" 
              size="small" 
              @click="handleQuickFilter('expired')"
              :class="{'is-active': quickFilter === 'expired'}"
            >
              已到期
            </el-button>
          </el-button-group>
          
          <div class="action-buttons">
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-plus" 
              @click="handleAdd"
              class="add-btn"
            >
              添加租赁
            </el-button>
            <el-button 
              size="small" 
              icon="el-icon-refresh" 
              @click="resetSearch"
              class="reset-btn"
            >
              重置
            </el-button>
          </div>
        </div>
      </div>
      
      <el-form :inline="true" :model="search_data" class="filter-form">
        <el-form-item label="租赁状态：" class="filter-item">
          <el-select 
            v-model="search_data.leaseStatus" 
            placeholder="请选择状态"
            clearable
            size="small"
            style="width: 120px;"
          >
            <el-option label="租赁中" value="active"></el-option>
            <el-option label="即将到期" value="expiring"></el-option>
            <el-option label="已到期" value="expired"></el-option>
            <el-option label="已退租" value="terminated"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="房间号：" class="filter-item">
          <el-input 
            v-model="search_data.roomNum" 
            placeholder="请输入房间号"
            clearable
            @keyup.enter.native="handleSearch"
            size="small"
            style="width: 150px;"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="公司名称：" class="filter-item">
          <el-input 
            v-model="search_data.tenantname" 
            placeholder="请输入公司名称"
            clearable
            @keyup.enter.native="handleSearch"
            size="small"
            style="width: 180px;"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="支付状态：" class="filter-item">
          <el-select 
            v-model="search_data.paymentStatus" 
            placeholder="支付状态"
            clearable
            size="small"
            style="width: 120px;"
          >
            <el-option label="已付清" value="paid"></el-option>
            <el-option label="未付清" value="unpaid"></el-option>
            <el-option label="部分支付" value="partial"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="区域：" class="filter-item">
          <el-select 
            v-model="search_data.area" 
            placeholder="选择区域"
            clearable
            size="small"
            style="width: 120px;"
          >
            <el-option label="南区" value="南区"></el-option>
            <el-option label="北区" value="北区"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="楼栋号：" class="filter-item">
          <el-input 
            v-model="search_data.buildingNum" 
            placeholder="请输入楼栋号"
            clearable
            @keyup.enter.native="handleSearch"
            size="small"
            style="width: 150px;"
          ></el-input>
        </el-form-item>
        
        <el-form-item class="filter-item">
          <el-button 
            type="primary" 
            icon="el-icon-search" 
            @click="handleSearch"
            size="small"
            class="search-btn"
          >
            查询
          </el-button>
          <el-button 
            icon="el-icon-download" 
            @click="handleExport"
            size="small"
            class="export-btn"
          >
            导出
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-summary">
          <span class="summary-item">
            共 <strong>{{ paginations.total }}</strong> 条记录
          </span>
          <span class="summary-item">
            租金总额: <strong class="revenue">{{ dashboardData.totalRentalAmount | currency }}</strong>
          </span>
          <span class="summary-item">
            总欠款: <strong class="arrears">{{ dashboardData.totalArrears | currency }}</strong>
          </span>
        </div>
      </div>
      
      <el-table 
        :data="tableData" 
        style="width: 100%" 
        max-height="500" 
        border 
        stripe
        v-loading="loading"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
        @sort-change="handleSortChange"
      >
        <el-table-column 
          type="index" 
          label="序号" 
          align="center" 
          width="60"
          fixed="left"
        >
        </el-table-column>
        <el-table-column 
          label="区域" 
          align="center" 
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ getSafeValue(scope.row, 'houseInfo.address', '-') }}
          </template>
        </el-table-column>
        <el-table-column 
          label="楼栋号" 
          align="center" 
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ getSafeValue(scope.row, 'houseInfo.building', '-') }}
          </template>
        </el-table-column>
        <el-table-column 
          label="房间号" 
          align="center" 
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ getSafeValue(scope.row, 'houseInfo.roomNum', '-') }}
          </template>
        </el-table-column>
        <el-table-column 
          label="公司名称" 
          align="center" 
          width="180"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ getSafeValue(scope.row, 'tenantInfo.tenantname', '-') }}
          </template>
        </el-table-column>
        <el-table-column 
          label="联系人" 
          align="center" 
          width="100"
        >
          <template slot-scope="scope">
            {{ getSafeValue(scope.row, 'tenantInfo.contact', '-') }}
          </template>
        </el-table-column>
        <el-table-column 
          label="联系方式" 
          align="center" 
          width="120"
        >
          <template slot-scope="scope">
            {{ getSafeValue(scope.row, 'tenantInfo.contactphone', '-') }}
          </template>
        </el-table-column>
        <el-table-column 
          prop="startdate" 
          label="开始日期" 
          align="center" 
          width="120" 
          sortable
          :formatter="dateFormat"
        >
        </el-table-column>
        <el-table-column 
          prop="enddate" 
          label="结束日期" 
          align="center" 
          width="120" 
          sortable
          :formatter="dateFormat"
        >
        </el-table-column>
        <el-table-column 
          prop="currentrentalamount" 
          label="租金" 
          align="center" 
          width="120"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.currentrentalamount | currency }}
          </template>
        </el-table-column>
        <el-table-column 
          prop="rentalStatus" 
          label="租赁状态" 
          align="center" 
          width="100"
        >
          <template slot-scope="scope">
            <el-tag 
              :type="getLeaseStatusType(scope.row.rentalStatus)"
              size="small"
            >
              {{ getLeaseStatusText(scope.row.enddate) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column 
          prop="isfullypaid" 
          label="支付状态" 
          align="center" 
          width="100"
        >
          <template slot-scope="scope">
            <el-tag 
              :type="getPaymentStatusType(scope.row.isfullypaid, scope.row.arrears)"
              size="small"
            >
              {{ getPaymentStatusText(scope.row.isfullypaid, scope.row.arrears) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column 
          prop="arrears" 
          label="欠款金额" 
          align="center" 
          width="120"
          sortable
        >
          <template slot-scope="scope">
            <div class="arrears-cell" :class="{'has-arrears': scope.row.arrears > 0}">
              {{ scope.row.arrears | currency }}
              <span v-if="scope.row.arrears > 0" class="days-overdue">
                ({{ calculateOverdueDays(scope.row.nextrentpaydate) }}天)
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column 
          prop="nextrentpaydate" 
          label="下次交租日" 
          align="center" 
          width="120"
          :formatter="dateFormat"
        >
        </el-table-column>
        <el-table-column 
          prop="remarks" 
          label="备注" 
          align="center" 
          width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column 
          label="操作" 
          align="center" 
          fixed="right"
          width="300"
        >
          <template slot-scope="scope">
            <el-button-group class="action-buttons">
              <el-button
                size="mini"
                type="info"
                icon="el-icon-view"
                @click="handleView(scope.row)"
                class="action-btn view-btn"
              >
                查看
              </el-button>
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-edit"
                @click="handleEdit(scope.$index, scope.row)"
                class="action-btn edit-btn"
              >
                编辑
              </el-button>
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="handleDelete(scope.$index, scope.row)"
                class="action-btn delete-btn"
              >
                删除
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          v-if='paginations.total > 0'
          :page-sizes="paginations.page_sizes"
          :page-size="paginations.page_size"
          :layout="paginations.layout"
          :total="paginations.total"
          :current-page.sync='paginations.page_index'
          @current-change='handleCurrentChange'
          @size-change='handleSizeChange'
          background
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 弹窗组件 -->
    <LeaseinfoAddDialog :dialog1="dialog1" @update="getProfile"></LeaseinfoAddDialog>
    <LeaseinfoEditDialog :dialog2="dialog2" @update="getProfile" :formData="Data"></LeaseinfoEditDialog>
    
    <!-- 查看详情弹窗 -->
    <el-dialog
      title="租赁信息详情"
      :visible.sync="viewDialog.show"
      width="60%"
      :close-on-click-modal="false"
      center
    >
      <el-descriptions
        :column="2"
        border
        class="view-detail"
      >
        <el-descriptions-item label="区域">
          {{ viewData.houseInfo ? viewData.houseInfo.address : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="楼栋号">
          {{ viewData.houseInfo ? viewData.houseInfo.building : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="房间号">
          {{ viewData.houseInfo ? viewData.houseInfo.roomNum : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="公司名称">
          {{ viewData.tenantInfo ? viewData.tenantInfo.tenantname : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="联系人">
          {{ viewData.tenantInfo ? viewData.tenantInfo.contact : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="联系方式">
          {{ viewData.tenantInfo ? viewData.tenantInfo.contactphone : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="租赁开始日期">
          {{ viewData.startdate ? dateFormat({startdate: viewData.startdate}, {property: 'startdate'}) : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="租赁结束日期">
          {{ viewData.enddate ? dateFormat({enddate: viewData.enddate}, {property: 'enddate'}) : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="租金">
          {{ viewData.currentrentalamount | currency }}
        </el-descriptions-item>
        <el-descriptions-item label="租赁状态">
          <el-tag :type="getLeaseStatusType(viewData.rentalStatus)">{{ getLeaseStatusText(viewData.enddate) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="支付状态">
          <el-tag :type="getPaymentStatusType(viewData.isfullypaid, viewData.arrears)">{{ getPaymentStatusText(viewData.isfullypaid, viewData.arrears) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="欠款金额">
          <span :class="{'has-arrears': viewData.arrears > 0}">{{ viewData.arrears | currency }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="下次交租日期">
          {{ viewData.nextrentpaydate ? dateFormat({nextrentpaydate: viewData.nextrentpaydate}, {property: 'nextrentpaydate'}) : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="逾期天数" v-if="viewData.arrears > 0">
          <span class="days-overdue">{{ calculateOverdueDays(viewData.nextrentpaydate) }}天</span>
        </el-descriptions-item>
        <el-descriptions-item label="备注" span="2">
          {{ viewData.remarks || '-' }}
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewDialog.show = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import leaseApi from '../api/leaseinfo.js'
import LeaseinfoEditDialog from '../components/LeaseinfoEditDialog'
import LeaseinfoAddDialog from '../components/LeaseinfoAddDialog'
import moment from 'moment'

export default {
  name: "leaseInfo",
  components: {
    LeaseinfoEditDialog,
    LeaseinfoAddDialog,
  },
  filters: {
    currency(value) {
      if (value === undefined || value === null || value === '') return '¥0.00'
      return `¥${parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
    }
  },
  data() {
    return {
      // 仪表盘数据
      dashboardData: {
        totalCount: 0,
        activeCount: 0,
        willExpireCount: 0,
        arrearsCount: 0,
        expiredCount: 0,
        totalArrears: 0,
        totalRent: 0,
        totalRentalAmount: 0, // 新增：租金总额
        monthlyRevenue: 0,
        activePercentage: 0,
        collectionRate: 0,
        trend: {
          total: 0,
          revenue: 0
        }
      },
      // 筛选条件数据
      search_data: {
        roomNum: '',
        tenantname: '',
        leaseStatus: '',
        paymentStatus: '',
        area: '',
        buildingNum: '',
        sortField: '',
        sortOrder: ''
      },
      // 快捷筛选
      quickFilter: '',
      // 分页配置
      paginations: {
        page_index: 1,
        total: 0,
        page_size: 20,
        page_sizes: [10, 20, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper"
      },
      tableData: [],
      allTableData: [],
      filteredData: [],
      loading: false,
      dialog1: {
        show: false,
        title: ""
      },
      dialog2: {
        show: false,
        title: ""
      },
      Data: {},
      // 查看弹窗相关
      viewDialog: {
        show: false
      },
      viewData: {}
    };
  },
  created() {
    this.getProfile();
  },
  methods: {
    // 安全获取嵌套属性的方法
    getSafeValue(obj, path, defaultValue = '') {
      if (!obj || !path) return defaultValue;
      try {
        const keys = path.split('.');
        let result = obj;
        
        for (const key of keys) {
          if (result === null || result === undefined || typeof result !== 'object') {
            return defaultValue;
          }
          result = result[key];
        }
        
        return result !== undefined && result !== null ? result : defaultValue;
      } catch (error) {
        console.warn('获取属性失败:', error);
        return defaultValue;
      }
    },
    
    getProfile() {
      this.loading = true;
      leaseApi.getAllLeaseInfos().then(res => {
        if (res.data.flag == true) {
          this.allTableData = res.data.data.map(item => {
            // 确保嵌套对象存在
            item.houseInfo = item.houseInfo || { address: '未分配', roomNum: '未知' };
            item.tenantInfo = item.tenantInfo || { 
              tenantname: '未分配', 
              contact: '-', 
              contactphone: '-' 
            };
            
            // 设置默认值
            item.houseInfo.address = item.houseInfo.address || '未分配';
            item.houseInfo.building = item.houseInfo.building || '未知';
            item.houseInfo.roomNum = item.houseInfo.roomNum || '未知';
            item.tenantInfo.tenantname = item.tenantInfo.tenantname || '未分配';
            item.tenantInfo.contact = item.tenantInfo.contact || '-';
            item.tenantInfo.contactphone = item.tenantInfo.contactphone || '-';
            
            // 其他字段的默认值
            item.startdate = item.startdate || '';
            item.enddate = item.enddate || '';
            item.currentrentalamount = item.currentrentalamount || 0; // 替换为currentrentalamount
            item.arrears = item.arrears || 0;
            item.isfullypaid = item.isfullypaid || '否';
            item.nextrentpaydate = item.nextrentpaydate || '';
            item.remarks = item.remarks || '';
            
            // 计算租赁状态
            item.rentalStatus = this.calculateLeaseStatus(item.enddate);
            // 计算是否欠租天数
            item.overdueDays = this.calculateOverdueDays(item.nextrentpaydate);
            return item;
          });
          this.calculateDashboardData();
          this.applyFilters();
        } else {
          this.$message.error('获取租赁信息列表失败');
        }
        this.loading = false;
      }).catch(error => {
        console.error('获取数据失败:', error);
        this.loading = false;
        this.$message.error('数据加载失败，请检查网络连接');
      });
    },
    
    calculateDashboardData() {
      const now = new Date();
      const nextMonth = new Date();
      nextMonth.setMonth(now.getMonth() + 1);
      const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
      const currentMonthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      
      let totalArrears = 0;
      let totalRentalAmount = 0; // 所有租金总和
      let monthlyRevenue = 0;
      let paidAmount = 0;
      
      this.allTableData.forEach(item => {
        // 计算欠款总额
        totalArrears += parseFloat(item.arrears || 0);
        
        // 计算租金总额（所有租赁的currentrentalamount之和）
        totalRentalAmount += parseFloat(item.currentrentalamount || 0);
        
        // 计算本月应收（保留原有逻辑）
        const leaseStart = item.startdate ? new Date(item.startdate) : null;
        const leaseEnd = item.enddate ? new Date(item.enddate) : null;
        
        if (leaseStart && leaseEnd && leaseStart <= currentMonthEnd && leaseEnd >= currentMonthStart) {
          monthlyRevenue += parseFloat(item.currentrentalamount || 0);
          if (item.isfullypaid === '是') {
            paidAmount += parseFloat(item.currentrentalamount || 0);
          }
        }
      });
      
      // 统计数量
      const activeCount = this.allTableData.filter(item => {
        if (!item.enddate) return false;
        const endDate = new Date(item.enddate);
        return endDate > now;
      }).length;
      
      const willExpireCount = this.allTableData.filter(item => {
        if (!item.enddate) return false;
        const endDate = new Date(item.enddate);
        return endDate > now && endDate <= nextMonth;
      }).length;
      
      const arrearsCount = this.allTableData.filter(item => 
        parseFloat(item.arrears || 0) > 0
      ).length;
      
      const expiredCount = this.allTableData.filter(item => {
        if (!item.enddate) return false;
        const endDate = new Date(item.enddate);
        return endDate <= now;
      }).length;
      
      this.dashboardData = {
        totalCount: this.allTableData.length,
        activeCount,
        willExpireCount,
        arrearsCount,
        expiredCount,
        totalArrears,
        totalRent: totalRentalAmount, // 兼容原有字段
        totalRentalAmount, // 新增字段：租金总额
        monthlyRevenue,
        activePercentage: this.allTableData.length > 0 ? 
          Math.round((activeCount / this.allTableData.length) * 100) : 0,
        collectionRate: monthlyRevenue > 0 ? 
          Math.round((paidAmount / monthlyRevenue) * 100) : 0,
        trend: {
          total: 5,
          revenue: 12
        }
      };
    },
    
    applyFilters() {
      let filtered = [...this.allTableData];
      
      // 应用快捷筛选
      if (this.quickFilter) {
        filtered = this.applyQuickFilter(filtered);
      }
      
      // 应用搜索条件
      filtered = this.applySearchFilters(filtered);
      
      // 应用排序
      if (this.search_data.sortField) {
        filtered = this.applySorting(filtered);
      }
      
      this.filteredData = filtered;
      this.setPaginations();
    },
    
    applyQuickFilter(data) {
      const now = new Date();
      const nextMonth = new Date();
      nextMonth.setMonth(now.getMonth() + 1);
      
      switch (this.quickFilter) {
        case 'active':
          return data.filter(item => {
            if (!item.enddate) return false;
            const endDate = new Date(item.enddate);
            return endDate > now;
          });
        case 'expiring':
          return data.filter(item => {
            if (!item.enddate) return false;
            const endDate = new Date(item.enddate);
            return endDate > now && endDate <= nextMonth;
          });
        case 'arrears':
          return data.filter(item => parseFloat(item.arrears || 0) > 0);
        case 'expired':
          return data.filter(item => {
            if (!item.enddate) return false;
            const endDate = new Date(item.enddate);
            return endDate <= now;
          });
        default:
          return data;
      }
    },
    
    applySearchFilters(data) {
      return data.filter(item => {
        // 房间号筛选
        if (this.search_data.roomNum) {
          const roomNum = this.getSafeValue(item, 'houseInfo.roomNum', '');
          if (!roomNum.includes(this.search_data.roomNum)) {
            return false;
          }
        }
        
        // 公司名称筛选
        if (this.search_data.tenantname) {
          const tenantname = this.getSafeValue(item, 'tenantInfo.tenantname', '');
          if (!tenantname.includes(this.search_data.tenantname)) {
            return false;
          }
        }
        
        // 区域筛选
        if (this.search_data.area) {
          const address = this.getSafeValue(item, 'houseInfo.address', '');
          if (address !== this.search_data.area) {
            return false;
          }
        }
        
        // 楼栋号筛选逻辑
        if (this.search_data.buildingNum) {
          const buildingNum = this.getSafeValue(item, 'houseInfo.building', '');
          if (!buildingNum.includes(this.search_data.buildingNum)) {
            return false;
          }
        }
        
        // 支付状态筛选
        if (this.search_data.paymentStatus) {
          if (this.search_data.paymentStatus === 'paid' && item.isfullypaid !== '是') {
            return false;
          }
          if (this.search_data.paymentStatus === 'unpaid' && item.isfullypaid === '是') {
            return false;
          }
          if (this.search_data.paymentStatus === 'partial' && 
            !(item.isfullypaid !== '是' && parseFloat(item.arrears || 0) < parseFloat(item.currentrentalamount || 0))) {
            return false;
          }
        }
        
        return true;
      });
    },
    
    applySorting(data) {
      const field = this.search_data.sortField;
      const order = this.search_data.sortOrder === 'ascending' ? 1 : -1;
      
      return [...data].sort((a, b) => {
        let valueA = this.getSafeValueForSort(a, field);
        let valueB = this.getSafeValueForSort(b, field);
        
        // 处理日期排序
        if (field.includes('date')) {
          valueA = valueA ? new Date(valueA).getTime() : 0;
          valueB = valueB ? new Date(valueB).getTime() : 0;
        }
        
        // 处理金额排序
        if (field === 'arrears' || field === 'currentrentalamount') {
          valueA = parseFloat(valueA || 0);
          valueB = parseFloat(valueB || 0);
        }
        
        if (valueA < valueB) return -1 * order;
        if (valueA > valueB) return 1 * order;
        return 0;
      });
    },
    
    getSafeValueForSort(obj, path) {
      if (!obj || !path) return '';
      const keys = path.split('.');
      let result = obj;
      
      for (const key of keys) {
        if (result === null || result === undefined || typeof result !== 'object') {
          return '';
        }
        result = result[key];
      }
      
      return result !== undefined && result !== null ? result : '';
    },
    
    handleSearch() {
      this.paginations.page_index = 1;
      this.applyFilters();
    },
    
    handleQuickFilter(type) {
      this.quickFilter = this.quickFilter === type ? '' : type;
      this.handleSearch();
    },
    
    resetSearch() {
      this.search_data = {
        roomNum: '',
        tenantname: '',
        leaseStatus: '',
        paymentStatus: '',
        area: '',
        buildingNum: '',
        sortField: '',
        sortOrder: ''
      };
      this.quickFilter = '';
      this.paginations.page_index = 1;
      this.applyFilters();
    },
    
    handleSortChange({ column, prop, order }) {
      this.search_data.sortField = prop;
      this.search_data.sortOrder = order;
      this.applyFilters();
    },
    
    calculateLeaseStatus(endDate) {
      if (!endDate) return 'unknown';
      const now = new Date();
      const end = new Date(endDate);
      const diffTime = end - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      if (diffDays < 0) return 'expired';
      if (diffDays <= 30) return 'expiring';
      return 'active';
    },
    
    calculateOverdueDays(nextPayDate) {
      if (!nextPayDate) return 0;
      const now = new Date();
      const nextPay = new Date(nextPayDate);
      const diffTime = now - nextPay;
      return Math.max(0, Math.floor(diffTime / (1000 * 60 * 60 * 24)));
    },
    
    getLeaseStatusType(status) {
      const typeMap = {
        'active': 'success',
        'expiring': 'warning',
        'expired': 'danger',
        'unknown': 'info'
      };
      return typeMap[status] || 'info';
    },
    
    getLeaseStatusText(endDate) {
      const status = this.calculateLeaseStatus(endDate);
      const textMap = {
        'active': '租赁中',
        'expiring': '即将到期',
        'expired': '已到期',
        'unknown': '未知'
      };
      return textMap[status] || '未知';
    },
    
    getPaymentStatusType(isFullyPaid, arrears) {
      if (isFullyPaid === '是') return 'success';
      if (parseFloat(arrears || 0) > 0) return 'danger';
      return 'warning';
    },
    
    getPaymentStatusText(isFullyPaid, arrears) {
      if (isFullyPaid === '是') return '已付清';
      if (parseFloat(arrears || 0) > 0) return '欠款中';
      return '待支付';
    },
    
    handleExport() {
      this.$message.success('导出功能开发中...');
    },
    
    // 查看详情方法
    handleView(row) {
      this.viewData = { ...row };
      this.viewDialog.show = true;
    },
    
    handleEdit(index, row) {
      this.Data = { ...row };
      this.dialog2 = {
        show: true,
        title: "修改租赁信息"
      };
    },
    
    handleAdd() {
      this.dialog1 = {
        show: true,
        title: "添加租赁信息"
      };
    },
    
    handleDelete(index, row) {
      this.$confirm('确认删除该租赁信息吗？此操作不可撤销。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'el-button--danger'
      }).then(() => {
        leaseApi.deleteleaseinfo(row.leaseid).then(res => {
          if (res.data.flag == true) {
            this.$message.success('删除成功');
            this.getProfile();
          } else {
            this.$message.error('删除失败');
          }
        }).catch(() => {
          this.$message.error('删除失败');
        });
      });
    },
    
    handleCurrentChange(page) {
      this.paginations.page_index = page;
      this.tableData = this.filteredData.slice(
        (page - 1) * this.paginations.page_size,
        page * this.paginations.page_size
      );
    },
    
    handleSizeChange(page_size) {
      this.paginations.page_index = 1;
      this.paginations.page_size = page_size;
      this.tableData = this.filteredData.slice(0, page_size);
    },
    
    setPaginations() {
      this.paginations.total = this.filteredData.length;
      this.paginations.page_index = 1;
      this.paginations.page_size = 20;
      this.tableData = this.filteredData.slice(0, this.paginations.page_size);
    },
    
    dateFormat(row, column) {
      var date = row[column.property];
      if (!date) return "-";
      return moment(date).format("YYYY-MM-DD");
    }
  }
}
</script>

<style scoped>
.fillcontain {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100%;
  box-sizing: border-box;
}

/* 仪表盘卡片样式 */
.dashboard-card {
  margin-bottom: 20px;
}

.card-item {
  border-radius: 8px;
  border: none;
  transition: all 0.3s ease;
  cursor: pointer;
  margin-bottom: 0;
}

.card-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.card-content {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.card-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 24px;
  color: white;
  flex-shrink: 0;
}

.total-card .card-icon { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
.active-card .card-icon { background: linear-gradient(135deg, #10b981 0%, #34d399 100%); }
.warning-card .card-icon { background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%); }
.arrears-card .card-icon { background: linear-gradient(135deg, #ef4444 0%, #f87171 100%); }
.expired-card .card-icon { background: linear-gradient(135deg, #6b7280 0%, #9ca3af 100%); }
.revenue-card .card-icon { background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%); }

.card-info {
  flex: 1;
  min-width: 0;
}

.card-title {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
  font-weight: 500;
}

.card-number {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  line-height: 1;
  margin-bottom: 4px;
}

.card-subtitle {
  font-size: 11px;
  color: #909399;
}

.card-trend {
  font-size: 10px;
  color: #10b981;
  font-weight: 500;
}

/* 筛选区域样式 */
.filter-card {
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: white;
}

.filter-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
  white-space: nowrap;
  flex-shrink: 0;
  margin-right: 20px;
}

.filter-title i {
  margin-right: 18px;
  color: #409EFF;
}

.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.el-button-group .el-button.is-active {
  background: #409EFF;
  border-color: #409EFF;
  color: white;
}

.add-btn {
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
  border: none;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.4);
}

.reset-btn {
  background: #909399;
  color: white;
  border: none;
}

.export-btn {
  background: #67c23a;
  color: white;
  border: none;
}

.filter-form {
  padding: 10px 0 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.filter-item {
  margin-bottom: 0;
}

.search-btn {
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
  border: none;
  color: white;
}

/* 表格区域样式 */
.table-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: white;
}

.table-header {
  padding: 15px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 15px;
}

.table-summary {
  display: flex;
  gap: 20px;
  font-size: 14px;
  color: #606266;
}

.summary-item strong {
  margin: 0 5px;
}

.revenue {
  color: #67c23a;
}

.arrears {
  color: #f56c6c;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 5px;
}

.action-btn {
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 4px;
  border: none;
  color: white;
}

/* 查看按钮样式 */
.view-btn { background: linear-gradient(135deg, #909399 0%, #b1b4b8 100%); }
.edit-btn { background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%); }
.delete-btn { background: linear-gradient(135deg, #f56c6c 0%, #f89898 100%); }

.arrears-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.arrears-cell.has-arrears {
  color: #f56c6c;
  font-weight: 600;
}

.days-overdue {
  font-size: 10px;
  color: #f59e0b;
  margin-top: 2px;
}

/* 分页样式 */
.pagination-container {
  padding: 20px 0;
  text-align: right;
  border-top: 1px solid #ebeef5;
  margin-top: 20px;
}

/* 查看详情弹窗样式 */
.view-detail {
  margin-top: 10px;
}

.view-detail .el-descriptions-item__label {
  font-weight: 600;
  background-color: #f8f9fa;
}

.view-detail .has-arrears {
  color: #f56c6c;
  font-weight: 600;
}

/* 响应式调整 */
@media (max-width: 1600px) {
  .dashboard-card .el-col {
    margin-bottom: 15px;
  }
  
  .card-number {
    font-size: 18px;
  }
  
  .card-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
    margin-right: 10px;
  }
}

@media (max-width: 1200px) {
  .dashboard-card .el-col {
    flex: 0 0 33.333%;
    max-width: 33.333%;
  }
  
  .filter-form {
    flex-direction: column;
  }
  
  .filter-item {
    width: 100%;
  }
  
  .filter-item .el-form-item__content {
    width: 100%;
  }
  
  .filter-item .el-input,
  .filter-item .el-select {
    width: 100% !important;
  }
}

@media (max-width: 768px) {
  .dashboard-card .el-col {
    flex: 0 0 50%;
    max-width: 50%;
  }
  
  .filter-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .el-button-group {
    width: 100%;
    display: flex;
  }
  
  .el-button-group .el-button {
    flex: 1;
  }
  
  .action-buttons {
    width: 100%;
  }
}
</style>